"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sanitize = (text) => text
    .toString()
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '');
/**
 * Creates an id from a list of strings and numbers along with 2 functions to access.
 * the id and postfix values generated.
 *
 * It santizies the arguments passed by:
 *    - converting any numbers to strings
 *    - converting all strings to lowercase
 *    - removing any spaces and replacing them with dashes
 *    - removes invalid characters, preserving only characters and numbers
 *    - ignoring any undefined or null
 *
 * EXAMPLE USAGE:
 *    id = generateId('my id')
 *    id.identity() = 'my-id'
 *    id.postfix('a postfix') = 'my-id_a-postfix'
 *
 * @param choices - a list of strings to concatenate
 * @returns {Object} - an object of functions
 *    {
 *      indentity(): function to return the generated id.
 *      postfix(string): function to build and return an id with an added postfix value.
 *     }
 *  *

 */
const generateId = (...choices) => {
    const id = sanitize(choices.find((choice) => choice));
    return {
        identity: () => id,
        postfix: (value) => `${id}_${sanitize(value)}`
    };
};
exports.default = generateId;
//# sourceMappingURL=generateId.js.map